// offersConfig.js

const offersConfig = {
  bookies: [
    {
      namePart1: "Sky",
      namePart1Color: "#1C3F92",
      namePart2: "Bet",
      namePart2Color: "#FF3838",
      offer: "£30 Free Bet",
      bgColor: "#FFF",
      textColor: "#000",
      url: "https://m.skybet.com/lp/acq-bet-x-get-30-2024"
    },
    {
      namePart1: "Bet",
      namePart1Color: "#fff",
      namePart2: "365",
      namePart2Color: "#FFE419",
      offer: "£30 Free Bet",
      bgColor: "#005340",
      textColor: "#fff",
      url: "https://www.bet365.com/"
    },
    {
      namePart1: "Virgin",
      namePart1Color: "#fff",
      namePart2: "Bet",
      namePart2Color: "#ffffff",
      offer: "£20 Free Bet",
      bgColor: "#E00C0B",
      textColor: "#fff",
      url: "https://www.virginbet.com/"
    }
  ],
  exchanges: [
    {
      namePart1: "S",
      namePart1Color: "#fff",
      namePart2: "markets",
      namePart2Color: "#fff",
      offer: "60 Days 0% Commission",
      bgColor: "#00AF73",
      textColor: "#fff",
      url: "https://smarkets.com/"
    },
    {
      namePart1: "Betfair",
      namePart1Color: "#000",
      namePart2: "",
      namePart2Color: "#000",
      offer: "2-5% Commission",
      bgColor: "#FEB809",
      textColor: "#000",
      url: "https://www.betfair.com/exchange/plus/"
    },
    // {
    //   namePart1: "Matchbook",
    //   namePart1Color: "#fff",
    //   namePart2: "",
    //   namePart2Color: "#ffffff",
    //   offer: "2% Commission",
    //   bgColor: "#C51A1B",
    //   textColor: "#fff",
    //   url: "https://www.virginbet.com/"
    // }
  ]
}
  
  export default offersConfig;
  